const formatAddress = (address: any) => {
  const { line_1, line_2, post_town, county } = address
  let trimmedLine_1 = ''
  let trimmedLine_2 = ''
  let trimmedPost_town = ''
  let trimmedCounty = ''

  if (line_1) trimmedLine_1 = line_1.trim()
  if (line_2) trimmedLine_2 = line_2.trim()
  if (post_town) trimmedPost_town = post_town.trim()
  if (county) trimmedCounty = county.trim()

  return [trimmedLine_1, trimmedLine_2, trimmedPost_town, trimmedCounty]
    .filter(Boolean)
    .join(', ')
}

export default formatAddress
